// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"8a2ee362","490":"67ef63a6","541":"434b36a7","706":"8aee556d","787":"006c9ef2","837":"5244185f"}[chunkId] + ".chunk.js";
};